import _ from 'underscore';
import $ from 'jquery';
import CxSelect from '@bingads-webui-component-legacy/cx-select/view/index';
import { OldHeaders as model } from '@bingads-webui-campaign-legacy/adextension-structuredsnippet/model/model';
import { detectLanguage } from '@bingads-webui-campaign-legacy/adextension-structuredsnippet/model/detect-language';
import { selectOptions } from '@bingads-webui-campaign-legacy/adextension-structuredsnippet/model/select-options';
import '@bingads-webui-component-legacy/extension/underscore';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');

function getI18n(key) {
  const ret = i18n.get(`Language_${key}`);

  return ret ? ret : key;
}

function findPairValueWithKey(pairs, key) {
  const [, value] = _.find(pairs, ([k]) => k === key) || [];

  return value;
}

function getExamples([lang = null, header] = []) {
  if (!lang) {
    return model[0][1][0][1];
  }

  const headers = findPairValueWithKey(model, lang) || [];

  return findPairValueWithKey(headers, header) || '';
}

export default class CxSelectView extends CxSelect {
  initialize({
    observable,
    field,
    viewModel,
  } = {}) {
    this.field = field;

    const value = observable();

    const opts = {
      i18n: {
        get: getI18n,
      },
      selectsCss: ['structured-snippet-category-layer-1', 'structured-snippet-category-layer-2'],
      selectsLabel: [i18n.get('StructuredSnippet_Texts_Language'), i18n.get('StructuredSnippet_Texts_Snippet')],
      selectOptions,
      value: value === '' ? undefined : value,
      id: field.id,
      labelledby: `${this.field.id}-Label`,
      describedby: `${this.field.id}-Validation`,
    };

    this.on('update', (newValue, path) => {
      observable(newValue === undefined ? '' : newValue);

      this.setExamples(getExamples(path));
    });

    super.initialize(opts);

    observable(_.isEmpty(value) ? _.last(this.getPath()) : value);
    this.initialExamples = getExamples(CxSelect.findValuePath(value, selectOptions));

    if (this.viewModel.isMultiMatch) {
      //detect path in other ways
      detectLanguage(viewModel.Texts()).then((path) => { //eslint-disable-line
        if (!_.isEmpty(path)) {
          this.trigger('update:path', [path, observable()]);
        }
      });
    }
  }

  render() {
    super.render();

    this.$el.append($('<div class="examples"></div>'));

    this.setExamples(this.initialExamples);

    return this;
  }

  setExamples(examples) {
    if (_.isEmpty(examples)) {
      return;
    }

    this.$('.examples').text(i18n.get('StructuredSnippet_Texts_Examples', { examples }));
  }
}
